import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import SuggestionsDef from 'fou-api/definitions/PackageSuggestionResponse'

export default {
  namespaced: true,

  state () {
    return {
      suggestions: {},
      getting: false,
      conversions: []
    }
  },

  getters: {
    suggestions: state => {
      return SuggestionsDef.build(state.suggestions)
    },
    conversions: state => {
      return state.conversions
    }
  },

  mutations: {
    set (state, suggestions = {}) {
      state.suggestions = suggestions
    },
    addConversion (state, conversion = {}) {
      if (Array.isArray(conversion.rates)) {
        state.conversions = conversion.rates
      }
    },
    getStart (state) {
      state.getting = true
    },
    getComplete (state) {
      state.getting = false
    }
  },

  actions: {
    get ({ commit, state }, submissionId) {
      return new Promise((resolve, reject) => {
        /**
         * state.getting prevents multiple calls at once
         */
        if (state.getting) {
          reject(Errors.create({
            message: 'Already fetching'
          }))
        }
        commit('getStart')
        Api.PackageSuggestions.getPackageSuggestions(submissionId)
          .then((response) => {
            commit('set', response.data)
            commit('getComplete')
            resolve(response)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            commit('getComplete')
            reject(err)
          })
      })
    },
    getCurrencyConversions ({ commit }) {
      return new Promise((resolve, reject) => {
        Api.Conversionrates.getConversionRates()
          .then((response) => {
            commit('addConversion', response.data)
            resolve(response)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
